module.exports = __webpack_public_path__ + "static/img/icon_06.57e5f78c.png";